'use client';

import { useUser } from '@medizzconnect/auth';
import { useState, useEffect } from 'react';

export type UserRoleType =
  | 'solo_doctor'
  | 'clinic_admin'
  | 'clinic_member'
  | 'client'
  | 'admin'
  | 'superadmin'
  | null;

/**
 * Client-Side Hook: Lädt die Rolle des Users aus der DB via /api/profile.
 * Gibt roleType und isLoading zurück.
 */
export function useUserRole(): { roleType: UserRoleType; isLoading: boolean } {
  const { user, isLoaded } = useUser();
  const [roleType, setRoleType] = useState<UserRoleType>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;

    if (!user) {
      setRoleType(null);
      setIsLoading(false);
      return;
    }

    fetch('/api/profile')
      .then(res => res.json())
      .then(data => {
        setRoleType((data?.user?.role_type as UserRoleType) ?? 'client');
      })
      .catch(() => setRoleType(null))
      .finally(() => setIsLoading(false));
  }, [user, isLoaded]);

  return { roleType, isLoading };
}
